var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { InboxInIcon, StarIcon } from '@heroicons/react/outline';
import * as React from 'react';
import * as NotificationsApi from '~/Api/Pigeon';
import { useApi, useApiResults } from '~/ApiHooks';
import { NotificationEmailDetailRoute, NotificationsFeedRoute } from '~/Application/routes';
import { Feed } from '~/NotificationList';
import { useSearchParams } from '~/Router';
import { ActivityIndicator, InfiniteScroll, Tab, Tabs } from '~/UI';
export var NotificationsFeed = function () {
    var _a;
    var params = useSearchParams();
    var status = (_a = params.get('status')) !== null && _a !== void 0 ? _a : NotificationsApi.NotificationStatus.All;
    var _b = useApiResults(React.useCallback(function (lastResponse) {
        var _a;
        return lastResponse === null || lastResponse.pagination.currentPage < lastResponse.pagination.totalPages
            ? new NotificationsApi.NotificationsRequest(((_a = lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.pagination.currentPage) !== null && _a !== void 0 ? _a : 0) + 1, 20, status)
            : null;
    }, [status]), [status]), results = _b[0], loadNext = _b[1], reload = _b[2];
    var apiSetRead = useApi()[0];
    var apiChangePriority = useApi()[0];
    // Update the state directly, without waiting for API reload, to make it feel instantaneous
    var _c = React.useReducer(notificationsReducer, [], function () { return []; }), notifications = _c[0], dispatch = _c[1];
    React.useEffect(function () {
        var _a;
        var allNotifications = [];
        (_a = results.value) === null || _a === void 0 ? void 0 : _a.map(function (values) { return allNotifications.push.apply(allNotifications, values.items); });
        dispatch({ type: 'load', notifications: allNotifications });
    }, [results]);
    var onSetRead = React.useCallback(function (notificationId) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: 'read', notificationId: notificationId });
                    return [4 /*yield*/, apiSetRead(new NotificationsApi.SetReadRequest([notificationId]))];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, reload((_b = (_a = results.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1)];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [results]);
    var onSetReadAll = React.useCallback(function (notificationIds) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({ type: 'readAll', notificationIds: new Set(notificationIds) });
                    return [4 /*yield*/, apiSetRead(new NotificationsApi.SetReadRequest(notificationIds))];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, reload((_b = (_a = results.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1)];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [results]);
    var onSetPriority = React.useCallback(function (notificationId, priority) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch({
                        notificationId: notificationId,
                        priority: priority ? NotificationsApi.NotificationPriority.High : NotificationsApi.NotificationPriority.Normal,
                        type: 'setPriority',
                    });
                    return [4 /*yield*/, apiChangePriority(new NotificationsApi.ChangePriorityRequest(priority, [notificationId]))];
                case 1:
                    _c.sent();
                    return [4 /*yield*/, reload((_b = (_a = results.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1)];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [results]);
    var BackLink = React.useCallback(function (props) { return <NotificationsFeedRoute.Link {...props}/>; }, []);
    var EmailBodyLink = React.useCallback(function (props) { return <NotificationEmailDetailRoute.Link {...props} newTarget={true}/>; }, []);
    return (<>
			<div className='container mx-auto'>
				<Tabs>
					<BackLink status={NotificationsApi.NotificationStatus.All.valueOf()}>
						<a>
							<Tab isSelected={status === NotificationsApi.NotificationStatus.All}>
								<InboxInIcon aria-hidden='true' className={"p-1 flex-shrink-0 inline h-7 w-7 cursor-pointer stroke-2 rounded-full"}/>{' '}
								Všechny
							</Tab>
						</a>
					</BackLink>
					<BackLink status={NotificationsApi.NotificationStatus.Priority.valueOf()}>
						<a>
							<Tab isSelected={status === NotificationsApi.NotificationStatus.Priority}>
								<StarIcon aria-hidden='true' className={"p-1 flex-shrink-0 inline h-7 w-7 cursor-pointer stroke-2 rounded-full"}/>{' '}
								Prioritní
							</Tab>
						</a>
					</BackLink>
				</Tabs>
			</div>
			{results.value === null ? (<ActivityIndicator />) : (<InfiniteScroll onLoad={loadNext}>
					<Feed EmailBodyLink={EmailBodyLink} notifications={notifications} status={status} onSetPriority={onSetPriority} onSetRead={onSetRead} onSetReadAll={onSetReadAll}/>
					{results.isLoading ? <ActivityIndicator /> : null}
				</InfiniteScroll>)}
		</>);
};
NotificationsFeed.displayName = 'Application.Screens.NotificationsFeed';
var notificationsReducer = function (items, action) {
    var _a;
    switch (action.type) {
        case 'load':
            return (_a = action.notifications) !== null && _a !== void 0 ? _a : [];
        case 'read':
            return items.map(function (item) {
                if (item.id !== action.notificationId) {
                    return item;
                }
                return __assign(__assign({}, item), { authenticatedRecipient: __assign(__assign({}, item.authenticatedRecipient), { isRead: true, readTime: new Date() }) });
            });
        case 'readAll':
            return items.map(function (item) {
                var _a, _b;
                var shouldItemChange = (_b = (_a = action.notificationIds) === null || _a === void 0 ? void 0 : _a.has(item.id)) !== null && _b !== void 0 ? _b : false;
                if (!shouldItemChange) {
                    return item;
                }
                return __assign(__assign({}, item), { authenticatedRecipient: __assign(__assign({}, item.authenticatedRecipient), { isRead: true, readTime: new Date() }) });
            });
        case 'setPriority':
            return items.map(function (item) {
                var _a;
                if (item.id !== action.notificationId) {
                    return item;
                }
                return __assign(__assign({}, item), { authenticatedRecipient: __assign(__assign({}, item.authenticatedRecipient), { priority: (_a = action.priority) !== null && _a !== void 0 ? _a : NotificationsApi.NotificationPriority.Normal }) });
            });
        default:
            return items;
    }
};
